import React, { useState } from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { VideoDisplay } from "./VideoDisplay";
import { WizardStyledBoxContainer } from "@/styles/theme";

interface FieldLayoutProps {
  label: string;
  description?: string;
  children: React.ReactNode;
  error?: boolean;
  helperText?: string;
  videoUrl?: string;
  transparent?: boolean;
}

export const FieldLayout: React.FC<FieldLayoutProps> = ({
  label,
  description,
  children,
  error,
  helperText,
  videoUrl,
  transparent = false,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  return (
    <WizardStyledBoxContainer sx={{ mb: 2, backgroundColor: transparent ? "transparent" : undefined }}>
      <Typography variant="h6">{label}</Typography>
      {description && <Typography>{description}</Typography>}
      {videoUrl && (
        <Accordion expanded={expanded} onChange={handleChange}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#FFF" }} />}>
            <Typography>Vídeo Explicativo</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {videoUrl && (
              <WizardStyledBoxContainer>
                <VideoDisplay url={videoUrl} sx={{ width: "100%" }} />
              </WizardStyledBoxContainer>
            )}
          </AccordionDetails>
        </Accordion>)}
      {children}

      {error && helperText && (
        <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
          {helperText}
        </Typography>
      )}
    </WizardStyledBoxContainer>);

};
